import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const ManagePagesLoader: LoadableType<{
	spaceKey: string;
}> = LoadablePaint({
	name: 'ManagePagesLoader',
	loader: async () => {
		return (await import(/* webpackChunkName: "loadable-ManagePages2" */ './ManagePagesV2.tsx'))
			.ManagePagesV2;
	},
});
